import React, { useEffect, useState, useRef } from 'react';
import { fetchVideos, fetchVideoBySlug } from '../../services/api';

const Video = ({ videoId }) => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentVideo, setCurrentVideo] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);


  const videoRef = useRef(null); // Ref for the modal video 

  const galleryRef = useRef(null);


  useEffect(() => {
  if (isFullScreen) {
    document.body.style.overflow = 'hidden'; // disable scrolling
  } else {
    document.body.style.overflow = ''; // restore scrolling
  }

  // Cleanup in case component unmounts
  return () => {
    document.body.style.overflow = '';
  };
}, [isFullScreen]);


  useEffect(() => {
    const fetchVideo = async () => {
      try {
        if (videoId) {
          const singleVideo = await fetchVideoBySlug(videoId, 'en');
          setCurrentVideo(singleVideo);
          setVideos([singleVideo]);
        } else {
          const allVideos = await fetchVideos('en');
          setVideos(allVideos);
          setCurrentVideo(allVideos[0]);
        }
        setLoading(false);
      } catch (err) {
        setError('Error fetching videos');
        setLoading(false);
      }
    };

    fetchVideo();
  }, [videoId]);

  const openFullScreen = (video, index) => {
    setCurrentVideo(video);
    setCurrentIndex(index);
    setIsFullScreen(true);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);

    // Stop the modal video playback
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const navigateVideo = (direction) => {
    let newIndex = currentIndex + direction;

    if (newIndex < 0) {
      newIndex = videos.length - 1; // Loop to the last video
    } else if (newIndex >= videos.length) {
      newIndex = 0; // Loop back to the first video
    }

    setCurrentVideo(videos[newIndex]);
    setCurrentIndex(newIndex);
  };

  // Helper function to render video content (embedded link)
  const renderVideoContent = (content) => {
    return { __html: content }; // This will safely inject HTML (e.g., iframe tags)
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  const handleGalleryScroll = () => {
  const gallery = galleryRef.current;
  if (!gallery) return;
  const { scrollLeft, scrollWidth, clientWidth } = gallery;

  setShowLeftArrow(scrollLeft > 10);
  setShowRightArrow(scrollLeft + clientWidth < scrollWidth - 10);
};

const scrollGallery = (direction) => {
  const gallery = galleryRef.current;
  if (!gallery) return;

  gallery.scrollBy({
    left: direction * gallery.clientWidth * 0.8,
    behavior: 'smooth',
  });
};


  return (
    <div>
      {!isFullScreen ? (
        <div style={{ position: 'relative' }}>
          {showLeftArrow && (
            <button
              onClick={() => scrollGallery(-1)}
              style={{
                position: 'absolute',
                left: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                height: '50px',
                width: '50px',
                borderRadius: '50%',
                background: 'white',
                border: 'none',
                fontSize: '3rem',
                cursor: 'pointer',
                zIndex: 10,
                color: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              }}
            >
              ‹
            </button>
          )}

          {showRightArrow && (
            <button
              onClick={() => scrollGallery(1)}
              style={{
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                height: '50px',
                width: '50px',
                borderRadius: '50%',
                background: 'white',
                border: 'none',
                fontSize: '3rem',
                cursor: 'pointer',
                zIndex: 10,
                color: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              }}
            >
              ›
            </button>
          )}
          <div className="video-gallery" style={{ display: 'flex', overflowX: 'auto' }} ref={galleryRef}             // <-- ADD THIS
            onScroll={handleGalleryScroll}
          >
            {/* "Click to open player" card */}
            <div
              className="video-thumbnail"
              style={{
                margin: '0 10px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#4B5563',
                color: 'white',
                fontSize: '25px',
                fontWeight: 'bold',
                borderRadius: '15px',
                height: '450px', // Adjust to match your video thumbnail size
                textAlign: 'center',
              }}
              onClick={() => setIsFullScreen(true)} // Opens the modal when clicked
            >
              Tap to watch full screen
            </div>

            {/* Video thumbnails */}
            {videos.map((video, index) => (
              <div
                key={video.id}
                className="video-thumbnail"
                style={{ margin: '0 10px', cursor: 'pointer' }}
                onClick={() => openFullScreen(video, index)}
              >

                {/* <h3>{video.title}</h3> */}
                <div dangerouslySetInnerHTML={renderVideoContent(video.description)} />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div
          className="full-screen-video"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'black',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <button
            onClick={closeFullScreen}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              fontSize: '2.5rem',
              color: 'white',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            &times;
          </button>


          <button
            onClick={() => navigateVideo(-1)}
            style={{
              position: 'absolute',
              top: '50%',
              left: '20px',
              transform: 'translateY(-50%)',
              fontSize: '4rem',
              color: 'white',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            ‹
          </button>


          {/* Display full-screen video content (embed) */}
          <div dangerouslySetInnerHTML={renderVideoContent(currentVideo.description)} />

          <button
            onClick={() => navigateVideo(1)}
            style={{
              position: 'absolute',
              top: '50%',
              right: '20px',
              transform: 'translateY(-50%)',
              fontSize: '4rem',
              color: 'white',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            ›
          </button>

        </div>
      )}
    </div>
  );
};

export default Video;
